import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';
import { TypedJourney } from "./journey.query";

/**
 *   Interface/model file auto generate for Promotion
 *   Interface for back-end
 *   Model for front-end.
 *   They are the same!
 */

export interface TypedPromotion {
    id?: string;
    promotion_name?: string;
    promotion_video_link?: string;
    event_type?: string; // ONBOARD', 'OFFBOARD // lên xe xuống xe
    journey_id?: string;
    is_active?: number;
    view_count?: number;
    createdAt?: string;
    promotion_schedule?: TypedPromotion_schedule;
    journey?: TypedJourney
}


/**
 *   Interface/model file auto generate for Promotion_schedule
 *   Interface for back-end
 *   Model for front-end.
 *   They are the same!
 */
export interface TypedPromotion_schedule {
    id?: string;
    promotion_id?: string;
    special_date?: number; // 1 nghĩa là có ưu tiên cái này nếu trùng lặp nhiều record thỏa mãn, 0 nghĩa là 0 ưu tiên
    weekday?: 'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT' | 'SUN' | 'ALL'; // ENUM('MON','TUE','WED','THU','FRI','SAT','SUN','ALL')
    start_time?: number; // 00:00:00
    end_time?: number; // 23:59:59
    start_date?: string;
    end_date?: string;
}


type IQuery = TypedPromotion & IQueryParams;


/*
* List of all app
*/
export function useGetPromotions(object?: IQuery) {
    return useQuery({
        queryKey: ["promotion/fetch_entity_list", object],
        queryFn: () => axios.get<TypedPromotion[]>(`/promotion${helpers.buildEndUrl(object)}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: !!object,
    });
}


export function useMutateGetPromotions() {
    return useMutation({
        mutationKey: ['promotion/fetch_entity_list'],
        mutationFn: (object: IQuery) => axios.get<TypedPromotion[]>(`/promotion/${helpers.buildEndUrl(object)}`).then((response) => response.data),
    });
}

export function useMutateGetPromotion() {
    return useMutation({
        mutationKey: ['promotion/fetch_entity'],
        mutationFn: (promotion_id: any) => axios.get<TypedPromotion>(`/promotion/${promotion_id}`).then((response) => response.data),
    });
}

export function useUpdatePromotion() {
    return useMutation({
        mutationKey: ['promotion/update_entity'],
        mutationFn: ({ id, ...rest }: TypedPromotion) => axios.patch<TypedPromotion>(`/promotion/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['promotion/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['promotion/fetch_entity'] });
        }
    });
}

export function useMutateCreatePromotion() {
    return useMutation({
        mutationKey: ['promotion/create_entity'],
        mutationFn: (entity: TypedPromotion) => axios.post<TypedPromotion>(`/promotion`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['promotion/fetch_entity_list'] });
        }
    });
}

export function useMutateDeletePromotion() {
    return useMutation({
        mutationKey: ['promotion/delete_entity'],
        mutationFn: (id: any) => axios.delete<TypedPromotion>(`/promotion/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['promotion/fetch_entity_list'] });
        }
    });
}

export function useMutateClonePromotion() {
    return useMutation({
        mutationKey: ['promotion/clone_entity'],
        mutationFn: (id: any) => axios.post<TypedPromotion>(`/promotion/clone/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['promotion/fetch_entity_list'] });
        }
    });
}


/** Tải về excel bản đang xem */
export function useDownloadPromotion() {
    return useMutation({
        mutationKey: ["promotion/download"],
        mutationFn: (transaction_id: any) => axios.get<Blob>(`/promotion/download/${transaction_id}`, { responseType: 'blob', }).then(response => response.data),
    })
}